document.addEventListener(
  'click',
  function (e) {
    // --- Botón "No" ---
    var btnNo = e.target.closest('[data-fct-no]');
    if (btnNo) {
      var root = btnNo.closest('[data-fct-root]');
      if (!root) return;

      var btnSi = root.querySelector('[data-fct-si]');
      var form = root.querySelector('[data-fct-form]');
      var errEl = root.querySelector('[data-fct-error]');

      root.dataset.fctQuiere = 'no';

      btnNo.classList.add('selected');
      if (btnSi) btnSi.classList.remove('selected');
      if (form) form.classList.remove('open');

      if (errEl) {
        errEl.textContent = 'Por favor completa todos los campos de factura.';
        errEl.classList.remove('open');
      }

      return;
    }

    // --- Botón "Sí" ---
    var btnSi = e.target.closest('[data-fct-si]');
    if (btnSi) {
      var root = btnSi.closest('[data-fct-root]');
      if (!root) return;

      var btnNo = root.querySelector('[data-fct-no]');
      var form = root.querySelector('[data-fct-form]');
      var errEl = root.querySelector('[data-fct-error]');

      root.dataset.fctQuiere = 'si';

      btnSi.classList.add('selected');
      if (btnNo) btnNo.classList.remove('selected');
      if (form) form.classList.add('open');

      if (errEl) {
        errEl.textContent = 'Por favor completa todos los campos de factura.';
        errEl.classList.remove('open');
      }

      return;
    }

    // --- Botón "Pagar" ---
    var pagar = e.target.closest('.cart__checkout-button');
    if (!pagar) return;

    var root = pagar.closest('[data-fct-root]');
    if (!root) return;

    var wrap = root.querySelector('[data-fct-wrap]');
    var errEl = root.querySelector('[data-fct-error]');

    // Primer click: mostrar el panel y NO dejar pagar todavía
    if (!wrap.classList.contains('open')) {
      e.preventDefault();
      wrap.classList.add('open');
      return;
    }

    var quiere = root.dataset.fctQuiere;

    // Si no ha elegido Sí o No, no dejar avanzar
    if (!quiere) {
      e.preventDefault();

      if (errEl) {
        errEl.textContent = 'Selecciona si requieres factura o no.';
        errEl.classList.add('open');
      }

      return;
    }

    // No quiere factura -> guardar factura genérica y dejar pasar
    if (quiere === 'no') {
      setFctNote(
        JSON.stringify(
          {
            rfc: 'XAXX010101000',
            nombre: 'PÚBLICO EN GENERAL',
            codigoPostal: '66633',
            regimenFiscal: '616',
            cfdi: 'S01'
          },
          null,
          4
        )
      );

      return;
    }

    // Quiere factura -> validar campos
    var rfc = root.querySelector('[data-fct-rfc]').value.trim();
    var nombre = root.querySelector('[data-fct-nombre]').value.trim();
    var cp = root.querySelector('[data-fct-cp]').value.trim();
    var uso = root.querySelector('[data-fct-uso]').value;
    var regimen = root.querySelector('[data-fct-regimen]').value;

    if (!rfc || !nombre || !cp || !uso || !regimen) {
      e.preventDefault();

      if (errEl) {
        errEl.textContent = 'Por favor completa todos los campos de factura.';
        errEl.classList.add('open');
      }

      return;
    }

    if (errEl) {
      errEl.textContent = 'Por favor completa todos los campos de factura.';
      errEl.classList.remove('open');
    }

    // Sí quiere factura -> guardar datos del cliente y dejar pasar
    setFctNote(
      JSON.stringify(
        {
          rfc: rfc,
          nombre: nombre,
          codigoPostal: cp,
          regimenFiscal: regimen,
          cfdi: uso
        },
        null,
        4
      )
    );
  },
  true
);

function setFctNote(value) {
  var cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  var ta = cartForm.querySelector('textarea[name="note"]');
  if (ta) {
    ta.value = value;
    return;
  }

  var old = cartForm.querySelector('[data-fct-note]');
  if (old) old.remove();

  var inp = document.createElement('input');
  inp.type = 'hidden';
  inp.name = 'note';
  inp.value = value;
  inp.setAttribute('data-fct-note', '');
  cartForm.appendChild(inp);
}